import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from "react-router-dom"
import Aux from '../containers/AuxContainer'
import imdbpro from '../assets/images/imdbpro.png'
class ImDb extends Component {

	state = { 
		showProjectLinkModal: false
	}

	componentWillUnMount() {
		
	}

	onOpenModal = () => {
			this.setState({ 
				showProjectLinkModal: true
			});
		}

	onCloseModal = () => {
			this.setState({ showProjectLinkModal: false });
		}

	render () {

		return (
			<Aux>
				<section className="section dirty-white">
	 				<div className="grid-x">
		 				<div className="small-12 small-centered cell text-center">
		 					<img src={imdbpro} width='150px'></img>
						</div>
					</div>
				</section>
			</Aux>
		)
	}
}

const mapStateToProps = state => ({
	project: state.projects.project,
	company: state.projects.company
})

export default connect(mapStateToProps)(ImDb)











// WEBPACK FOOTER //
// ./src/components/ImDb.js